// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://kzh-002-staging.herokuapp.com/api/v1',
  reCaptcha: {
    siteKey: '6Lee3M0ZAAAAAIRnh0HosWH87pjIvfQDs3Y5qS6C',
    siteSecret: '6Lee3M0ZAAAAADKKt3dBgU74nt1yMT9LCmTSo8D_'
  },
  matmo: {
    siteId: 53,
    url: '//app.friendlyanalytics.io/'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
